import { render, staticRenderFns } from "./OutsourcingDetail.vue?vue&type=template&id=343efb42&"
import script from "./OutsourcingDetail.vue?vue&type=script&lang=js&"
export * from "./OutsourcingDetail.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports